import request from '@/axios/index.js'
export function joinSave(data,loading) {
    return request.axios({
        loading:loading,
        data:data,
        url: '/biz-cst-apply-to-join/save'
    })
}


// WEBPACK FOOTER //
// ./src/api/web.js